import React, {useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAgreement, weddingHallContract } from "@src/@slice/weddingHallContractSlice";
import Checkbox from "@src/components/common/checkbox/Checkbox";
import NoticeToast from "@src/components/weddingHall/NoticeToast";
import PersonalPolicy from "@src/components/weddingHall/reservation/PersonalPolicy";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import Blank from "@src/components/common/blank/Blank";

// 웨딩홀 예식계약서 약관 및 개인정보 수집 동의 모달컴포넌트
const WeddingHallPolicies = ({ openModalInfo, closeModal }) => {
  const dispatch = useDispatch();
  const policyType:string = openModalInfo.target; // 0:개인정보수집 1: 2: 약관내용 및 취소수수료
  const isReadOnly = openModalInfo.onlyRead;
  const policyRef = useRef<HTMLDivElement>(null);
  const ref1 = useRef(null); // 웨딩홀 개인정보 수집
  const ref2 = useRef(null); // 웨딩북 제3자 제공 동의
  const agreeData = useSelector(weddingHallContract).data.agreement; // 예식계약서 정보들

  const [title, setTitle] = useState("");
  const [content, setContent] = useState(null);
  const [isScrolledToEnd, setIsScrolledToEnd] = useState<boolean>(false);
  const [isChecked0, setIsChecked0] = useState<boolean>(agreeData.personalPolicy); // 개인정보 수집 및 이용 동의
  const [isChecked1, setIsChecked1] = useState<boolean>(agreeData.contractRefund); // 약관 내용 및 취소 수수료 동의

  //스크롤 하단 감지 이벤트
  const handleScroll = () => {
    if (policyRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = policyRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setIsScrolledToEnd(true);
      }
    }
  };

  useEffect(() => {
    policyRef?.current?.addEventListener("scroll", handleScroll)
    return () => {
      policyRef?.current?.removeEventListener("scroll", handleScroll);
    }
  }, [policyRef.current]);

  useEffect(()=> {
    if(policyRef.current){
      const { scrollHeight, clientHeight } = policyRef?.current;
      if (scrollHeight <= clientHeight && isChecked1) {
        setIsScrolledToEnd(true);
      } 
    }
  },[isChecked1])

  useEffect(()=>{
    setIsChecked0(agreeData.personalPolicy)
    setIsChecked1(agreeData.contractRefund)
  },[agreeData.personalPolicy, agreeData.contractRefund])


  useEffect(() => {
    switch (policyType) {
      case "0":
        setTitle("");
        setContent(<PersonalPolicy type={policyType} content={openModalInfo.policy} ref1={ref1} ref2={ref2}/>);
        break;
      case "1":
        setTitle("");
        setContent(<PersonalPolicy type={policyType} content={openModalInfo.policy}  ref1={ref1} ref2={ref2}/>);
        break;
      case "2":
        setTitle("약관내용 및 취소수수료와 위약금");
        setContent(<p>{openModalInfo.policy}</p>);
        break;
      case "3":
        setTitle("개인정보수집 제공 및 활용 동의");
        setContent(<p>{openModalInfo.policy}</p>);
        break;
      default:
        setTitle("");
        setContent(null);
        break;
    }
  }, [policyType]);

  const scrollToPolicy = (policyType) => {
    if (policyRef.current) {
      if(policyType === '0' && ref1.current){
          ref1.current.scrollIntoView({ behavior: 'smooth' });
      }else if(policyType === '1' && ref2.current){
          ref2.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  
  return (
    <>
      {openModalInfo.open && (
        <div className="page-weddinghall-policies hide-scroll">
          <CustomHeader goBack={() => closeModal()} close={() => closeModal()} scrollHide={false}/>
          <h2 className="title bold">{title}</h2>
          <PolicyWrap ref={policyRef} isReadOnly={isReadOnly} hasToast={policyType !== '0'}>
            <>{content}</> {/** 컴포넌트(태그)를 상태로 가지고 있습니다. */}
            <Blank height={20} />
          </PolicyWrap>

          {/* 예식 계약서 하단 동의 체크박스*/}
          {!isReadOnly && (
            <>
              {isScrolledToEnd === false && policyType !== '0' ?
                <NoticeToast hasMark={false} notice="모든 내역을 읽고 체크버튼을 눌러 주세요." btnName="" bottom={55}/>
                :
                <Blank height={52} />
              }
              <div className="agree-box-wrap">
                <>
                {policyType === '0' || policyType === '1' ?
                  <>
                    <div className="checkbox-wrap">
                      <Checkbox
                        id={`personal-agree-policy`}
                        name="policy"
                        value={`개인정보 수집 및 이용, 개인정보 제3자 제공 동의를 모두 읽었으며 이에 동의합니다.`}
                        setValue={() => {
                            setIsChecked0(!isChecked0);
                            dispatch(setAgreement({ keyname: "personalPolicy", checked: !isChecked0 }));
                        }}
                        checked={isChecked0}
                      />
                      <p>
                          <span onClick={()=>scrollToPolicy('0')}>개인정보 수집 및 이용</span>, <span onClick={()=>scrollToPolicy('1')} >개인정보 제3자 제공 동의</span>를 모두 읽었으며 이에 동의합니다. 
                      </p>
                    </div>
                    <button className={`btn btn-full btn-giant ${isChecked0 ? "btn-red500" : "btn-disabled"}`}onClick={closeModal}>확인</button>
                  </>
                  :
                  <>
                    <div className="checkbox-wrap">
                      <Checkbox
                        id='refund-agree-policy'
                        name="policy"
                        value='약관 내용 및 취소 수수료와 위약금에 대해 모두 읽었으며 이에 동의합니다.'
                        setValue={() => {
                          dispatch(setAgreement({ keyname: "contractRefund", checked: !isChecked1 }));
                          setIsChecked1(!isChecked1);
                        }}
                        checked={isChecked1}
                      />
                      <p>약관 내용 및 취소 수수료와 위약금에 대해 모두 읽었으며 이에 동의합니다.</p>
                    </div>
                    <button className={`btn btn-full btn-giant ${isChecked1 && isScrolledToEnd ? "btn-red500" : "btn-disabled"}`} onClick={closeModal}>
                      확인
                    </button>
                  </>
                }
                </>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default WeddingHallPolicies;

type PolicyWrapProps = {
  isReadOnly: boolean;
  children: React.ReactNode;
  hasToast:boolean
};

const PolicyWrap = React.forwardRef<HTMLDivElement, PolicyWrapProps>(
  ({ isReadOnly, children ,hasToast}, ref) => {
    return (
      <div ref={ref} className={`policy-content ${isReadOnly ? "read-mode" : ""}`} style={{height:hasToast?'calc(100vh - 265px)':'calc(100vh - 250px)'}}>
        {children}
      </div>
    );
  },
);
